import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
export default {
	mixins:[HttpFactory],
	data () {
		return {
            tabIndex:0,
            hdJSONString: null,
            hdReplyJSONString:null,
            params:{requestType:null,appId:null,installationId:null,userEmail:null,userId:null,account:null},
            filters:{searchText:null},
            userInfo:null,
            replySync:false
		};
	},
	created(){
        const _self=this;
		_self.init();
	},
	methods:{
        async init() {
            const _self = this;
            //http://localhost:8080/el/devops/zendesk-devops/463/394508/360002271937/support@devopsintegration.io/ticket
            this.params={
                requestType:this.$route.params[`requestType`],
                appId:this.$route.params[`appId`],
                installationId:this.$route.params[`installationId`],
                userEmail:this.$route.params[`userEmail`],
                userId:this.$route.params[`userId`],
                account:this.$route.params[`account`],
            };
            
            if (_self.$route.query.replySync=='true') {
                _self.replySync = true;
            }
            this.initHttpSettings_noPrefix(true);
            this.fetchData();
        },
        async fetchData(){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data={
                        searchText:_self.filters.searchTextAPI,
                        appId:this.params.appId,
                        installationId:this.params.installationId,
                        userId:this.params.userId
                };
                let response=await _self.post(`${this.params.requestType}/webhookInfo/get?userId=${this.params.userId}`,data);
                if(response && response.data && response.data.Data){
                    _self.userInfo=response.data.Data;
                    _self.userInfo.requestType=_self.params.requestType;
                    _self.copyHDSyncJSON(_self.userInfo);
                    if (_self.replySync) {
                        _self.copyReplyHDSyncJSON(_self.userInfo);
                    }
                    
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        copyHDSyncJSON(item){
            const _self=this;
            let hdJSONString;
            switch(item.requestType){
                case 'zendesk-devops':
                    hdJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "comment_id":"{{ticket.latest_comment.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "account":"{{ticket.account}}",
                            "ticket_status":"{{ticket.status}}",
                            "brandname":"{{ticket.brand.name}}",
                            "current_username":"{{current_user.name}}",
                            "current_useremail":"{{current_user.email}}",
                            "current_user_first_name":"{{current_user.first_name}}",
                            "ticket_latest_comment_formatted":"{{ticket.latest_comment_formatted}}",
                            "ticket_latest_comment":"{{ticket.latest_comment}}",
                            "is_public":"{{ticket.latest_comment.is_public}}",
                            "attachments":"{{ticket.latest_comment.attachments}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl":"{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshdesk-devops':
                    hdJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment": "{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment_text1": "{{ticket.latest_private_comment_text1}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "ticket_agent_name": "{{ticket.agent.name}}",
                            "ticket_agent_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshservice-devops':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment":"{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment1":"{{ticket.latest_private_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'monday-devops':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment":"{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment1":"{{ticket.latest_private_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                default:
                    break;
            }
            hdJSONString=JSON.stringify(hdJSONString);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{devOpsUrl}}",item.devOpsUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{appId}}",item.appId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{installationId}}",item.installationId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{requestType}}",item.requestType);
            _self.hdJSONString=hdJSONString;
            //_self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        copyReplyHDSyncJSON(item){
            const _self=this;
            let hdReplyJSONString;
            switch(item.requestType){
                case 'zendesk-devops':
                    hdReplyJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "comment_id":"{{ticket.latest_comment.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "account":"{{ticket.account}}",
                            "ticket_status":"{{ticket.status}}",
                            "brandname":"{{ticket.brand.name}}",
                            "current_username":"{{current_user.name}}",
                            "current_useremail":"{{current_user.email}}",
                            "current_user_first_name":"{{current_user.first_name}}",
                            "ticket_latest_comment_formatted":"{{ticket.latest_comment_formatted}}",
                            "ticket_latest_comment":"{{ticket.latest_comment}}",
                            "is_public":"{{ticket.latest_comment.is_public}}",
                            "attachments":"{{ticket.latest_comment.attachments}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl":"{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshdesk-devops':
                    hdReplyJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment": "{{ticket.latest_public_comment}}",
                            "ticket_latest_private_comment_text1": "{{ticket.latest_public_comment_text1}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "ticket_agent_name": "{{ticket.agent.name}}",
                            "ticket_agent_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshservice-devops':
                    hdReplyJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment":"{{ticket.latest_public_comment}}",
                            "ticket_latest_private_comment1":"{{ticket.latest_public_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'monday-devops':
                    hdReplyJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment":"{{ticket.latest_public_comment}}",
                            "ticket_latest_private_comment1":"{{ticket.latest_public_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                default:
                    break;
            }
            hdReplyJSONString=JSON.stringify(hdReplyJSONString);
            hdReplyJSONString=_self.fn().replaceAll(hdReplyJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdReplyJSONString=_self.fn().replaceAll(hdReplyJSONString,"{{devOpsUrl}}",item.devOpsUrl);
            hdReplyJSONString=_self.fn().replaceAll(hdReplyJSONString,"{{appId}}",item.appId);
            hdReplyJSONString=_self.fn().replaceAll(hdReplyJSONString,"{{installationId}}",item.installationId);
            hdReplyJSONString=_self.fn().replaceAll(hdReplyJSONString,"{{requestType}}",item.requestType);
            _self.hdReplyJSONString=hdReplyJSONString;
            //_self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        
        copyHDSyncURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url = `https://devopsintegration.io/api/${item.requestType}/${type}/syncing?appId=${item.appId}&installationId=${item.installationId}&account=${account}`
            if (item.requestType == 'monday')
                url+=`&devOpsUrl=${item.devOpsUrl}&isPublic=false`
            _self.doCopyVal(url, 'HD Syncing URL copied');
            //https://devopsintegration.io/api/monday-devops/monday/syncing?appId=25503427&installationId=25503427&account=d3v-devopsintegration&devOpsUrl=https://dev.azure.com/devopsintegrationio&isPublic=false&isLocal=false
        },
        onCopy(e){
            this.userMsg={show:true,type:'primary',list:['You just copied: ' + e.text]};
        },
        async doCopyVal(message,successMsg){
            const _self=this;
            let isCopied=await _self.$copyText(message)
            if(isCopied){
                _self.userMsg={show:true,type:'primary',list:['You just copied: ' + successMsg?successMsg:message]};
            }
        },
    },
    components:{}
}

//http://localhost:8080/el/sync-setup/devops/freshservice-devops/146/fs_146/fs_146/devopsintegration.dev@gmail.com/ticket